<ng-template #modalOptimizationTemplate>
  <div class="modal-optimization">
    <div class="modal-header bg-ternary text-center">
      <button
        type="button"
        class="close pull-right text-white"
        aria-label="Close"
        (click)="modalOptimization.hide()"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <h4
        class="modal-title semi-bold mtl mbm text-white"
        [innerHtml]="optimization.label"
      ></h4>
    </div>
    <div class="modal-body">
      <p class="semi-bold text-blue fs-14 mbxl mtxl inline-table">
        NOUVELLES OPPORTUNITÉS
      </p>
      <div class="badge badge-round fs-14 mlm">3</div>
      @for (value of amountSave; track value) {
        <div class="ea-card mbm shadow" (click)="selectLoan(value)">
          <div
            class="gradient-border"
            [style.background-color]="optimization.style.backgroundColor"
          ></div>
          @if (optimization.key == 'LOAN_FIX_RATE') {
            <p class="primary-text fs-14 man">
              Economisez {{ value.montant }}&euro;
            </p>
          }
          @if (optimization.key == 'LIFE_INSURANCE') {
            <p class="primary-text fs-14 man">
              {{ optim.current.label | translate }}
            </p>
          }
        </div>
      }
      <!-- <div class="ea-card shadow mbm">
      <div class="gradient-border" [style.background-color]="'#3376f6'"></div>
      <p class="primary-text fs-14 man">Economisez jusqu’a 23 700€ sur vos crédits !</p>
    </div>
    <div class="ea-card shadow mbm">
      <div class="gradient-border" [style.background-color]="'#3376f6'"></div>
      <p class="primary-text fs-14 man">Economisez jusqu’a 23 700€ sur vos crédits !</p>
    </div> -->
      <!-- <p class="semi-bold inline-table fs-14 mbxl mtxl">AUTRES OPPORTUNITÉS </p>
    <div class="badge badge-round bg-ternary fs-14 mlm">3</div>

    <div class="ea-card shadow mbm">
      <div class="gradient-border" [style.background-color]="'#3376f6'"></div>
      <p class="primary-text fs-14 man">Economisez jusqu’a 23 700€ sur vos crédits !</p>
    </div>
    <div class="ea-card shadow mbm">
      <div class="gradient-border" [style.background-color]="'#3376f6'"></div>
      <p class="primary-text fs-14 man">Economisez jusqu’a 23 700€ sur vos crédits !</p>
    </div>
    <div class="ea-card shadow mbm">
      <div class="gradient-border" [style.background-color]="'#3376f6'"></div>
      <p class="primary-text fs-14 man">Economisez jusqu’a 23 700€ sur vos crédits !</p>
    </div> -->

      <!-- <div *ngFor="let optim of optimization.value" (click)="optim.route = optimization.route;
      modalOptimization.hide();
      notificationsService.goToNotification(optim)">
    <div class="content mbm" *ngIf="optimization.key == 'LOAN_FIX_RATE'">
      <svg-icon-sprite [src]="'assets/svg/sprite.svg#eye'" [viewBox]="'0 0 24 24'" [width]="'22px'"
      [classes]="'text-primary pointer-cursor'"></svg-icon-sprite>
      <p class="fw-600">{{optim.loanTitle | translate}} </p>
      <p class="text-blue">Economisez {{optim.keepsMonthly.amount }}</p>
      <p>Crédit immobilier</p>
    </div>

    <div class="content mbm"
      *ngIf="optimization.key == 'LIFE_INSURANCE'">
      <svg-icon-sprite [src]="'assets/svg/sprite.svg#eye'" [viewBox]="'0 0 24 24'" [width]="'14px'"
            [classes]="'text-primary pointer-cursor'" (click)="optim.route = optimization.route;
            modalOptimization.hide();
            notificationsService.goToNotification(optim)"></svg-icon-sprite>
      <p class="fw-600">{{optim.current.label}} </p>
      <p class="text-blue">Economisez {{optim.current.currentValue | currency:'EUR':'symbol':'1.0-0' }}</p>
    </div>
  </div> -->
    </div>
  </div>
</ng-template>
